/* Omnitub — policy page enhancer (legal policy pages only).
   Adds: hoisted "Last updated" line into the masthead, an auto
   "On this page" table of contents for long policies, horizontally
   scrollable tables, and a company colophon. Progressive: if the
   expected DOM isn't present it simply does nothing. */
(function () {
  function init() {
    var container = document.querySelector('.shopify-policy__container');
    var bodyWrap = document.querySelector('.shopify-policy__body');
    var rte = bodyWrap && bodyWrap.querySelector('.rte');
    var title = document.querySelector('.shopify-policy__title');
    if (!rte) return;

    /* Hoist a "Last updated…" paragraph into the masthead */
    if (title) {
      var ps = rte.querySelectorAll('p');
      for (var i = 0; i < Math.min(ps.length, 3); i++) {
        if (/last updated/i.test(ps[i].textContent)) {
          ps[i].classList.add('omni-policy-updated');
          title.appendChild(ps[i]);
          break;
        }
      }
    }

    /* Wrap tables for horizontal scroll on small screens */
    rte.querySelectorAll('table').forEach(function (t) {
      if (t.parentElement.classList.contains('omni-policy-tablewrap')) return;
      var w = document.createElement('div');
      w.className = 'omni-policy-tablewrap';
      t.parentNode.insertBefore(w, t);
      w.appendChild(t);
    });

    /* Build the table of contents from h2 headings (long policies only) */
    var heads = rte.querySelectorAll('h2');
    if (heads.length >= 5 && bodyWrap) {
      var nav = document.createElement('nav');
      nav.className = 'omni-policy-toc';
      nav.setAttribute('aria-label', 'On this page');
      var h = document.createElement('p');
      h.className = 'omni-policy-toc__title';
      h.textContent = 'On this page';
      nav.appendChild(h);
      var ol = document.createElement('ol');
      var seen = {};
      heads.forEach(function (head, idx) {
        var id = head.id;
        if (!id) {
          id = (head.textContent || ('section-' + idx)).toLowerCase()
            .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || ('section-' + idx);
          if (seen[id]) { id = id + '-' + idx; }
          seen[id] = true;
          head.id = id;
        }
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + id;
        a.textContent = head.textContent.trim();
        li.appendChild(a);
        ol.appendChild(li);
      });
      nav.appendChild(ol);
      bodyWrap.parentNode.insertBefore(nav, bodyWrap);
    }

    /* Company colophon */
    if (container && !container.querySelector('.omni-policy-foot')) {
      var foot = document.createElement('div');
      foot.className = 'omni-policy-foot';
      foot.innerHTML = 'Omnitub Ltd · Registered in England &amp; Wales, Company No. 05008946 · VAT GB236392792<br>'
        + 'Questions about this policy? <a href="mailto:info@omnitub.co.uk">info@omnitub.co.uk</a> · '
        + '<a href="tel:+441934751200">+44 1934 751200</a>';
      container.appendChild(foot);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
